import React from 'react';
import { Box, Flex } from '@mafc/trolly';
import { Check } from '@mafc/icon';
import styled from '@emotion/styled';

import { StepsStatusType, EStepsStatus } from '../interfaces/stepsProgress.interface';
import COLORS from 'theme/colors';

interface Props {
  [K: string]: any;
}

type CustomFC<T = {}> = React.FC<Props & T>;

const BG_COLORS = {
  [EStepsStatus.disabled]: 'doveGrey',
  [EStepsStatus.active]: 'blue',
  [EStepsStatus.completed]: COLORS.GREEN,
};

interface CardFC extends CustomFC {
  Header: CustomFC<{ status?: StepsStatusType; step?: number }>;
  Title: CustomFC;
  Step: CustomFC;
  Content: any;
}

const Card: CardFC = props => (
  <Box mt={3} p={[null, null, 3]} bg={[null, null, 'white']} {...props} />
);

Card.Header = ({ children, status = EStepsStatus.disabled, step = 1, rtl = false, ...rest }) => (
  <Flex alignItems="center" {...rest}>
    <Card.Step bg={BG_COLORS[status]} rtl={rtl}>
      {status === EStepsStatus.completed ? <Check testid="Check" size="XS" fill="#fff" /> : step}
    </Card.Step>

    {children}
  </Flex>
);

Card.Title = props => (
  <Box as="h2" color={COLORS.BLACK} fontSize={3} fontWeight="bold" mx={0} {...props} />
);

Card.Step = ({ bg = BG_COLORS[EStepsStatus.disabled], rtl = false, ...rest }) => (
  <Box
    alignItems="center"
    bg={bg}
    color="white"
    fontSize={2}
    fontWeight={4}
    display={['none', null, 'flex']}
    height="24px"
    justifyContent="center"
    mr={rtl ? 0 : 2}
    ml={!rtl ? 0 : 2}
    sx={{ borderRadius: 5 }}
    width="24px"
    {...rest}
  />
);

// Card.Content = props => <Box mb={['14px', null, 0]} {...props} />;
Card.Content = styled(Box)``;
Card.Content.defaultProps = {
  mb: ['14px', null, 0],
  minHeight: ['12px', '', 0],
};

export default Card;
